export type Timeframe = '1m' | '3m' | '5m' | '15m' | '30m' | '1h' | '4h' | '1D' | '1W' | '1M'

export interface OHLCV {
  t: number  // Unix epoch seconds
  o: number
  h: number
  l: number
  c: number
  v: number
}

// Columnar format returned by the API (compact)
export interface CandleArray {
  t: number[]
  o: number[]
  h: number[]
  l: number[]
  c: number[]
  v: number[]
}

export interface CandleResponse {
  data: CandleArray
  meta: {
    ticker: string
    timeframe: Timeframe
    count: number
    from: number
    to: number
    source: 'cache' | 'yahoo' | 'hyperliquid'
  }
}

export const TIMEFRAME_SECONDS: Record<Timeframe, number> = {
  '1m': 60,
  '3m': 180,
  '5m': 300,
  '15m': 900,
  '30m': 1800,
  '1h': 3600,
  '4h': 14400,
  '1D': 86400,
  '1W': 604800,
  '1M': 2592000,
}

export const TIMEFRAME_LABELS: Record<Timeframe, string> = {
  '1m': '1m',
  '3m': '3m',
  '5m': '5m',
  '15m': '15m',
  '30m': '30m',
  '1h': '1H',
  '4h': '4H',
  '1D': '1D',
  '1W': '1W',
  '1M': '1M',
}

export const ALL_TIMEFRAMES: Timeframe[] = ['1m', '3m', '5m', '15m', '30m', '1h', '4h', '1D', '1W', '1M']
